<template>
  <div>
    <topHead v-show="show==true" />
    <router-view @footshow="handelshow" />
    <toFoot v-show="show==true" />
  </div>
</template>
<script>
import topHead from '@/views/components/header.vue'
import toFoot from '@/views/components/commonFoot'
import { getClasszSystem } from '@/api/api.js'

export default {
  components: { topHead, toFoot },
  data() {
    return {
      show: true
    }
  },
  watch: {
    $route(to, from) {
      if (to.name !== 'roots') {
        this.show = true
      } else {
        this.show = false
      }
    }
  },
  mounted() {
    if (this.systemConfig.systemConfig.isMFB) {
      // getClasszSystem().then(res => {
      //   console.log(res.data)
      // })
    }
  },
  methods: {
    handelshow(index) {
      if (index <= 7) {
        this.show = true
      } else {
        this.show = false
      }
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>

</style>
